
// pages/Pipeline.jsx
import React from 'react';
import PipelineKanban from '../../components/CRM/PipelineKanban';

const Pipeline = () => {
  return <PipelineKanban />;
};

export default Pipeline;
